import axios from "axios"

const OcrService = {
    uploadAndRetrieve: async (filePath: string) => {
        const { data } = await axios.post("ocr", { filePath })
        return data
    },
}

export default OcrService
